module.exports = __webpack_public_path__ + "static/img/report.6a45776e.svg";